import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var contentRootLegacy = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_ybwy2f0',variantClassNames:{layout:{column:'fx_2d2fb1e5_ybwy2f1'}},defaultVariants:{},compoundVariants:[]});
var styledContentLegacy = 'fx_2d2fb1e5_ybwy2f4';

export { contentRootLegacy, styledContentLegacy };
//# sourceMappingURL=contentLegacy.vanilla.mjs.map
